<template>
  <div class="FooterView" id="footer">
    <p class="footer-item" v-if="$txt != null">
      <em
        >Version:
        <span id="version">{{ $ds.current_version.version }}</span>
        Build: <span id="build">{{ $ds.current_version.build }}</span> (
        <span id="date">{{ $ds.current_version.date }}</span> )
      </em>
    </p>
    <p class="footer-item" v-if="$txt != null">
      <em
        >API: <span id="api_server">{{ $net.api_server }}</span><span v-if="$net.api_version"> v{{ $net.api_version }}</span></em
      >
    </p>
    <a
      class="footer-item"
      v-if="$ds.session.logged_in && $txt != null"
      @click="$appm.log_out()"
      >{{ $txt.sign_out }}</a
    >

    <a
      class="footer-item"
      v-if="$ds.settings.developer_mode"
      @click="show_debug_modal = true"
      >Debug window</a
    >
    <a
      class="footer-item"
      v-if="$ds.settings.developer_mode"
      id="dev_mode_btn"
    >
      <router-link :to="{ name: 'sketch', params: {} }">Sketch</router-link>
    </a>

    <a
      v-if="support_access_available && $txt != null"
      class="footer-item footer-item-right"
      :class="{ 'footer-item-disabled': support_has_access }"
      @click="give_access_to_support()"
      >{{ support_has_access ? "Support has been given access" : $txt.give_access_to_support }}</a
    ><!-- TODO: language key for "Support has been given access" -->

    <Modal
      title="Debug window"
      v-if="show_debug_modal"
      :width="900"
      @close="show_debug_modal = false"
      data-default-esc
    >
      <DebugControls :starting_page="starting_debug_page" />
    </Modal>
  </div>
</template>

<script>
export default {
  name: "FooterView",

  mounted() {
    document.onkeydown = (event) => {
      if (!this.$ds.settings.developer_mode) return;

      if (event.which == 191) {
        this.starting_debug_page = "node_inspect";
        this.show_debug_modal = !this.show_debug_modal;
      }
    };
  },

  data() {
    return {
      show_debug_modal: false,
    };
  },

  computed: {
    support_access_available() {
      const project = this.$app.sltd.project;
      return Boolean(project && this.$route.params.project_id && project.dto.canGrant);
    },
    support_has_access() {
      return this.$app.sltd.project.support_user_exists(this.$app);
    },
    support_project_id() {
      return this.support_access_available ? this.$app.sltd.project.id : null;
    }
  },

  methods: {
    give_access_to_support() {
      if (this.support_has_access) return;
      this.$app.sltd.project.add_support_user(this.$app.sltd.project.id);
    }
  },

  watch: {
    // Whether support has access is read from the project's grants, which are
    // otherwise only loaded when the access panel is opened.
    support_project_id: {
      immediate: true,
      handler(id) {
        if (id != null) this.$net.project_grant.list(id);
      }
    }
  },
};
</script>
